import React from "react";
import "./RulesTxt.less";
// 弹窗的类型定义
interface RulesTxtProps {
  onClose: () => void; // 关闭弹窗的回调函数
}

// 弹窗组件
const RulesTxt: React.FC<RulesTxtProps> = ({ onClose }) => {
  return (
    <div className="rulesTxt" onClick={onClose}>
      <div className="content" onClick={(e) => e.stopPropagation()}>
        <div className="ruleContent">
          <div className="reluTxt">
            <span className="index">1.</span>
            领取成功后,相关充电权益将发放至您手机号对应的账号中,请使用相应手机号登录并使用;
          </div>
          <div className="reluTxt">
            <span className="index">2.</span>
            若兑换的产品为会员卡,您可以在会员中心查看会员有效期、会员特权、可用权益包等常见问题;
          </div>
          <div className="reluTxt">
            <span className="index">3.</span>
            兑换码仅能兑换一次,不得转赠,不予退换
          </div>
          <div className="reluTxt">
            <span className="index">4.</span>
            本权益仅限在小鹏汽车App、小鹏汽车微信小程序、小鹏充电微信小程序使用;
          </div>
          <div className="reluTxt">
            <span className="index">5.</span>仅限中国大陆,不包含港澳台地区使用;
          </div>
          <div className="reluTxt">
            <span className="index">6.</span>
            手机号限制,多个账号同一手机号登录,视为同一用户;
          </div>
        </div>
      </div>
      <div className="iknow-btn-green" onClick={onClose}>
        我知道了
      </div>
    </div>
  );
};

export default RulesTxt;
